import React from 'react'
import Footer from '../components/footer';

export default () => {

    return (
        <section className={`intro flex justify-start`}>
            <div className="flex col">
                <h1>GDO <br/> studio </h1>
                <div className="flex">
                    <span>Design</span>
                    <span>Programming</span>
                    <span>AI</span> 
                </div>
            </div>
            <Footer />
        </section>
    )
}